import React from 'react';
import { Button } from 'react-bootstrap';
import classnames from 'classnames';
import styles from './addAssociationButton.module.scss';

interface AddAssociationButtonProps {
  onClick: () => void;
  label: string;
  fitContentBtn?: boolean;
}

const AddAssociationButton = ({
  onClick,
  label,
  fitContentBtn,
}: AddAssociationButtonProps) => {
  return (
    <Button
      type="button"
      className={classnames(styles.addAssociationButton, {
        [styles.fitContent]: fitContentBtn,
      })}
      variant="secondary"
      size="sm"
      onClick={onClick}
      disabled={false}
      data-cy={`addButton:${label?.replaceAll(' ', '-')}`}
    >
      {label}
    </Button>
  );
};

export default AddAssociationButton;
